export default "__VITE_ASSET__6256d884__"